import {makeAutoObservable, reaction} from "mobx";
import {KeyValue} from "./keyValue";
import {
  allVillageKeyValue,
  defaultMinMultiSelectRequired
} from "../../shared/constants";

export class MultiVillageSelectObservableList {
  selectedItems: KeyValue[];
  items: KeyValue[];
  isDirty: boolean;
  minRequired: number;

  constructor(
    items: KeyValue[],
    selectedItemValues: KeyValue[],
    minRequired = defaultMinMultiSelectRequired,
    onSelectedItemsChange?: (items: KeyValue[]) => void
  ) {
    makeAutoObservable(this);
    this.items = items;
    this.selectedItems = selectedItemValues;
    this.isDirty = false;
    this.minRequired = minRequired;

    if (onSelectedItemsChange) {
      reaction(() => this.selectedItems, onSelectedItemsChange);
    }
  }

  setIsDirty = (value: boolean) => {
    this.isDirty = value;
  };

  setSelectedItems(items: KeyValue[]): void {
    this.selectedItems = items;

    if (this.selectedItems.length > 0) {
      this.setIsDirty(true);
    }
  }

  setItems(items: KeyValue[]): void {
    this.items = items;
  }

  allVillageOptionSelected(): boolean {
    return (
      this.selectedItems.findIndex(
        (value) => value.value === allVillageKeyValue.value
      ) >= 0
    );
  }

  get isValid() {
    return (
      this.allVillageOptionSelected() ||
      this.selectedItems.length >= this.minRequired
    );
  }
}
